import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private httpClient: HttpClient;
  private cache = new Map<string, string>();

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  public async getSvg(url: string): Promise<any> {
    let svg: any = this.cache.get(url);

    if (svg) {
      return svg;
    }
    try {
      svg = await this.httpClient
        .get(url, { responseType: 'text' })
        .toPromise();
      this.cache.set(url, svg);
    } catch (e) {
      console.warn(`Could not load ${url}`);
    }
    return svg;
  }

  public async getImage(url: string): Promise<any> {
    let base64 = this.cache.get(url);
    if (base64) {
      return base64;
    }
    try {
      const blob: any = await this.httpClient
        .get(url, { responseType: 'blob' })
        .toPromise();
      base64 = await this.blobToBase64(blob);
      this.cache.set(url, base64);
    } catch (e) {
      console.warn(`Could not load ${url}`);
    }
    return base64;
  }

  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise<any>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          resolve(null);
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
}
